'use strict';

var processInclude = require('BASE/util');
var base = require('./product/base');
$(document).ready(function() {
  require('./components/product-fixaddtocart')('.add-to-cart-stickybar');
  base.addToCart();
  processInclude(require('./product/detail'));  
});
